import React from "react";
import MxTextDateField, {
  MxTextDateFieldProps
} from "@rf-l1/form/text-fields/MxTextDateField";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";
import { IEventChangeCallBack } from "@rf-model/event-change.model";

type omit = "name" | "id" | "value" | "renderInput" | "onChange" | "ref";
export type MxFormTextDateFieldProps = Omit<MxTextDateFieldProps, omit>
const MxFormTextDateField = React.forwardRef(
  (props: MxFormTextDateFieldProps, ref) => {
    const { onChange, onBlur, name, value, invalid, id, inputRef } =
      useMxFieldControllerContext();
      
    const onHandleBlur = (e: IEventChangeCallBack<any>) => {
      onBlur(e as any);
      if (props.onBlur) {
        props.onBlur(e as any);
      }
    };

    return (
      <MxTextDateField
        {...props}
        id={id}
        ref={ref || inputRef}
        onChange={onChange}
        onBlur={onHandleBlur}
        name={name}
        value={value}
        error={invalid}
      />
    );
  }
);

export default MxFormTextDateField;
